import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "p-fluid p-ai-end p-formgrid p-grid" }
const _hoisted_2 = { class: "p-field p-col-5 p-mb-5" }
const _hoisted_3 = { class: "p-float-label" }
const _hoisted_4 = {
  for: "label",
  class: "kn-material-input-label"
}
const _hoisted_5 = { class: "p-field p-col-5 p-mb-5" }
const _hoisted_6 = { class: "p-float-label" }
const _hoisted_7 = {
  for: "name",
  class: "kn-material-input-label"
}
const _hoisted_8 = { class: "p-field p-col-2 p-mb-5" }
const _hoisted_9 = {
  for: "typeLovDropdown",
  class: "kn-material-input-label"
}
const _hoisted_10 = { class: "p-field p-col-12 p-mb-5" }
const _hoisted_11 = { class: "p-float-label" }
const _hoisted_12 = {
  for: "description",
  class: "kn-material-input-label"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")
  const _component_KnValidationMessages = _resolveComponent("KnValidationMessages")
  const _component_Dropdown = _resolveComponent("Dropdown")
  const _component_Card = _resolveComponent("Card")

  return (_openBlock(), _createBlock(_component_Card, { class: "p-m-2" }, {
    content: _withCtx(() => [
      _createVNode("form", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode("span", _hoisted_3, [
            _createVNode(_component_InputText, {
              id: "label",
              class: ["kn-material-input", {
                                'p-invalid': _ctx.v$.lov.label.$invalid && _ctx.v$.lov.label.$dirty
                            }],
              type: "text",
              modelValue: _ctx.v$.lov.label.$model,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.v$.lov.label.$model = $event)),
              modelModifiers: { trim: true },
              maxLength: "20",
              onBlur: _cache[2] || (_cache[2] = ($event: any) => (_ctx.v$.lov.label.$touch())),
              onInput: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('touched')))
            }, null, 8, ["modelValue", "class"]),
            _createVNode("label", _hoisted_4, _toDisplayString(_ctx.$t('common.label')) + " * ", 1)
          ]),
          _createVNode(_component_KnValidationMessages, {
            vComp: _ctx.v$.lov.label,
            additionalTranslateParams: {
                            fieldName: _ctx.$t('common.label')
                        },
            specificTranslateKeys: {
                            custom_unique_label: 'managers.lovsManagement.lovLabelNotUnique'
                        }
          }, null, 8, ["vComp", "additionalTranslateParams", "specificTranslateKeys"])
        ]),
        _createVNode("div", _hoisted_5, [
          _createVNode("span", _hoisted_6, [
            _createVNode(_component_InputText, {
              id: "name",
              class: ["kn-material-input", {
                                'p-invalid': _ctx.v$.lov.name.$invalid && _ctx.v$.lov.name.$dirty
                            }],
              type: "text",
              modelValue: _ctx.v$.lov.name.$model,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.v$.lov.name.$model = $event)),
              modelModifiers: { trim: true },
              maxLength: "50",
              onBlur: _cache[5] || (_cache[5] = ($event: any) => (_ctx.v$.lov.name.$touch())),
              onInput: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('touched')))
            }, null, 8, ["modelValue", "class"]),
            _createVNode("label", _hoisted_7, _toDisplayString(_ctx.$t('common.name')) + " * ", 1)
          ]),
          _createVNode(_component_KnValidationMessages, {
            vComp: _ctx.v$.lov.name,
            additionalTranslateParams: {
                            fieldName: _ctx.$t('common.name')
                        },
            specificTranslateKeys: {
                            custom_unique_name: 'managers.lovsManagement.lovNameNotUnique'
                        }
          }, null, 8, ["vComp", "additionalTranslateParams", "specificTranslateKeys"])
        ]),
        _createVNode("div", _hoisted_8, [
          _createVNode("span", null, [
            _createVNode("label", _hoisted_9, _toDisplayString(_ctx.$t('managers.lovsManagement.lovType')) + " * ", 1),
            _createVNode(_component_Dropdown, {
              id: "typeLovDropdown",
              class: ["kn-material-input", {
                                'p-invalid': _ctx.v$.lov.itypeCd.$invalid && _ctx.v$.lov.itypeCd.$dirty
                            }],
              modelValue: _ctx.v$.lov.itypeCd.$model,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.v$.lov.itypeCd.$model = $event)),
              options: _ctx.listOfInputTypes,
              optionLabel: "VALUE_NM",
              optionValue: "VALUE_CD",
              placeholder: _ctx.$t('managers.lovsManagement.lovTypePlaceholder'),
              "aria-label": "dropdown",
              onBeforeShow: _cache[8] || (_cache[8] = ($event: any) => (_ctx.v$.lov.itypeCd.$touch())),
              onChange: _ctx.typeChanged
            }, null, 8, ["class", "modelValue", "options", "placeholder", "onChange"])
          ]),
          _createVNode(_component_KnValidationMessages, {
            vComp: _ctx.v$.lov.itypeCd,
            additionalTranslateParams: {
                            fieldName: _ctx.$t('managers.lovsManagement.lovType')
                        }
          }, null, 8, ["vComp", "additionalTranslateParams"])
        ]),
        _createVNode("div", _hoisted_10, [
          _createVNode("span", _hoisted_11, [
            _createVNode(_component_InputText, {
              id: "description",
              class: "kn-material-input",
              type: "text",
              modelValue: _ctx.lov.description,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.lov.description = $event)),
              modelModifiers: { trim: true },
              maxLength: "160",
              onInput: _cache[10] || (_cache[10] = ($event: any) => (_ctx.$emit('touched')))
            }, null, 8, ["modelValue"]),
            _createVNode("label", _hoisted_12, _toDisplayString(_ctx.$t('managers.lovsManagement.description')), 1)
          ])
        ])
      ])
    ]),
    _: 1
  }))
}